<template>
  <div :class="['app-container', { 'bdc-list-page': isBdc }]">
    <!-- 工具栏 -->
    <div class="filter-container" :class="{ 'bdc-filter-bar': isBdc }">
      <el-button class="filter-item" type="primary" size="small" icon="el-icon-circle-plus-outline" @click="handleAdd">添加用户组</el-button>
      <el-input class="filter-item" size="small" v-model="search" clearable placeholder="名称模糊查询" style="width:200px;"></el-input>

      <!-- 表格header 筛选 -->
      <div class="filterTableHeader" style="float:right;" v-if="isAdmin_Vip && !isBdc">
        <el-popover width="400" trigger="click">
          <el-button slot="reference" size="small" icon="el-icon-s-grid" style="font-size: 16px;padding:5px 10px;" title="筛选列"><i class="el-icon-caret-bottom"></i></el-button>
          <el-checkbox-group class="checkbox-table-headers" v-model="checkboxTitle">
            <el-checkbox v-for="(item,index) in tableTheadOptions" :key="index" :label="item">{{item[Object.keys(item)[0]]}}</el-checkbox>
          </el-checkbox-group>
        </el-popover>
      </div>
    </div>

    <!-- 表格 -->
    <div ref="bdcTableArea" :class="{'bdc-table-area': isBdc}">
    <el-table class="grayTableTile" size="small" v-loading="listLoading" :data="tableList" border style="width: 100%" :height="tableHeightDaily" @sort-change="handleAgeSortChange" row-key="id" :tree-props="{children: 'childs', hasChildren: 'hasChildren'}">
      <el-table-column v-for="(item,index) in tableTheads" :key="index" :label="item[Object.keys(item)[0]]" :prop="Object.keys(item)[0]" sortable='custom'>
        <template slot-scope="scope">
          <span v-if="Object.keys(item)[0] == 'name'" style="color:#646cf5;cursor: pointer;" @click="juesexiangqing(scope.row)">{{ scope.row[Object.keys(item)[0]]}}</span>
          <span v-else>{{ scope.row[Object.keys(item)[0]]}}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="440">
        <template slot-scope="scope">
          <div class="bdc-table-op-cell">
            <el-button type="text" class="bdc-table-op-muted" @click="tianjiazizu(scope.row)">添加子用户组</el-button>
            <el-button type="text" class="bdc-table-op-muted" @click="bianjijuese(scope.row)">编辑</el-button>
            <el-button type="text" class="bdc-table-op-danger" @click="shanchujuese(scope.row)">删除</el-button>
            <el-button type="text" class="bdc-table-op-muted" @click="handleAddGroups(scope.row)">添加组成员</el-button>
          </div>
        </template>
      </el-table-column>

    </el-table>
    </div>

    <!-- 分页 -->
    <bdc-table-footer>
      <template v-if="isAdmin_Vip" #actions>
        <el-popover width="400" trigger="click">
          <bdc-column-filter-button slot="reference" />
          <el-checkbox-group class="checkbox-table-headers" v-model="checkboxTitle">
            <el-checkbox v-for="(item,index) in tableTheadOptions" :key="index" :label="item">{{item[Object.keys(item)[0]]}}</el-checkbox>
          </el-checkbox-group>
        </el-popover>
      </template>
      <pagination v-show="total>0" :auto-scroll="false" :background="!isBdc" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize" :class="isBdc ? 'bdc-table-pagination' : ''" />
    </bdc-table-footer>

    <!-- 添加 编辑权限 -->
    <el-dialog :title="formType == 'add' ? '添加用户组' : formType == 'edit' ? '编辑用户组' : '添加子用户组'" v-if="addjuese" :visible.sync="addjuese" width="500px">
      <el-form ref="form" :model="form" :rules="formRules" label-width="110px">
        <el-form-item label="用户组名称：" prop="name">
          <el-input size="small" v-model="form.name" style="width:200px"></el-input>
        </el-form-item>

        <el-form-item label="显示名称：" prop="desc">
          <el-input size="small" v-model="form.desc" style="width:200px"></el-input>
        </el-form-item>
      </el-form>

      <!-- 按钮组 -->
      <div class="dialog-butn-box" style="margin-top: 20px">
        <el-button size="small" type="primary" @click="handleSave">确认</el-button>
        <el-button size="small" @click="addjuese=false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 详情 -->
    <group-info ref="group" @handleAddGroups="handleAddGroups"></group-info>

    <!--右侧抽屉 穿梭框 添加分组 -->
    <transfer v-if="drawer" ref="transfer" :title="drawertitle" @getTransferList="getTransferList" @handleSave="handleSaveDrawer"></transfer>

  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import BdcTableFooter from '@/components/BdcTableFooter'
import BdcColumnFilterButton from '@/components/BdcTableFooter/BdcColumnFilterButton'
import { grouplist, groupmerge, groupdelete, userfilterHas, userdoAssignGroups } from '@Sys~/api/sys'
import { arrSlice, sortKeys } from '@/filters'
import GroupInfo from '../components/groupInfo'
import Transfer from '../components/transferCollapse'
import bdcListTableHeight from '@Sys~/utils/bdcListTableHeight'

const defaultFormThead = [
  { name: '用户组名称' },
  { desc: '显示名称' },
  { id: 'ID' },
]

const defaultChecked = [
  { name: '用户组名称' },
  { desc: '显示名称' },
]

// 弹窗默认的数据内容
const defaultFrom = {
  name: '', // 用户组名称
  desc: '', // 显示名称
}

export default {
  mixins: [bdcListTableHeight],
  components: { Pagination, BdcTableFooter, BdcColumnFilterButton, GroupInfo, Transfer },
  data() {
    return {
      search: '',
      isAdmin_Vip: this.$store.getters.roles.indexOf('admin') > -1 || this.$store.getters.roles.indexOf('vip') > -1,

      // 表格
      listLoading: false,
      originalCaseTable: [],// 排序原始数据
      caseTable: [], // 存放后端一次性返回的所有数据
      handCaseTable: [], // 存放处理假分页后的数据(等距切割)
      tableData: [], // 切割后页面应展示的数据
      tableTheadOptions: defaultFormThead,
      checkboxTitle: defaultFormThead.filter(item => !item.id), // 排除id项，并使用同一引用,
      tableTheads: defaultChecked,

      total: 0,
      listQuery: {
        pageNo: 1,
        pageSize: 10
      },

      // 创建 编辑用户组
      formType: 'add',
      formRules: {
        name: [{ required: true, trigger: ['blur', 'change'], message: '请填写用户组名称' }],
        desc: [{ required: true, trigger: ['blur', 'change'], message: '请填写显示名称' }]
      },
      form: {},
      addjuese: false,

      // 右侧抽屉
      drawer: false,
      drawertitle: "",
      jueseinfo: {}

    }
  },
  watch: {
    // 筛选table header
    checkboxTitle(valArr) {
      this.tableTheads = this.tableTheadOptions.filter(i => JSON.stringify(valArr).indexOf(JSON.stringify(i)) > -1)
    }
  },
  computed: {
    isBdc() {
      return process.env.VUE_APP_PROJECT_TYPE === 'bdc'
    },
    // 筛选列表表
    tableList() {
      let caseTable = this.caseTable
      const search = this.search.toLowerCase().replace(/\s+/g, "");
      if (search) {
        caseTable = this.caseTable.filter(data => {
          return String(data['id']).toLowerCase().indexOf(search) > -1
            || String(data['name']).toLowerCase().indexOf(search) > -1
            || String(data['desc']).toLowerCase().indexOf(search) > -1
        })
      }

      this.total = caseTable.length
      // 将一维数组切割成二维数组
      this.handCaseTable = arrSlice(caseTable, this.listQuery.pageSize)
      this.tableData = this.handCaseTable[this.listQuery.pageNo - 1]
      return this.tableData
    }
  },

  created() {
    this.getList()
  },
  methods: {
    // 获取列表
    getList() {
      this.listLoading = true
      grouplist().then(response => {
        this.listLoading = false
        if (response.code == 1) {
          this.caseTable = response.data
          this.originalCaseTable = JSON.parse(JSON.stringify(this.caseTable))
        }
      })
    },

    // 监听排序变化
    handleAgeSortChange(e) {
      if (e.order) {
        const order = e.order == 'descending' ? false : true
        this.caseTable.sort(sortKeys(e.prop, order))
      } else {
        this.caseTable = JSON.parse(JSON.stringify(this.originalCaseTable))
      }
    },

    // 添加用户组
    handleAdd() {
      this.addjuese = true
      this.formType = 'add'
      this.form = JSON.parse(JSON.stringify(defaultFrom))
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },

    // 添加子用户组
    tianjiazizu(row) {
      this.addjuese = true
      this.formType = 'addSon'
      this.form = {
        name: "",//
        desc: "",//
        pid: row.id,//
      }
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },

    // 编辑
    bianjijuese(row) {
      this.addjuese = true
      this.formType = 'edit'
      this.form = JSON.parse(JSON.stringify(row))
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },

    // 确认 添加或编辑用户
    handleSave() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          groupmerge(this.form).then(response => {
            if (response.code == 1) {
              this.$message({
                message: this.formType = 'add' ? "添加用户组成功" : this.formType = 'edit' ? "编辑用户组成功" : '添加子用户组成功',
                type: "success"
              });
              this.getList();
              this.addjuese = false;
            }
          });
        }
      })
    },

    // 删除
    shanchujuese(row) {
      this.$confirm('确认删除用户组： "' + row.desc + '" 吗？').then(_ => {
        groupdelete(row.id).then(response => {
          if (response.code == 1) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.getList();
          }
        });
      }).catch(_ => { });
    },

    // 详情
    juesexiangqing(row) {
      this.$refs['group'].init(row)
    },

    // 添加组成员
    handleAddGroups(row) {
      this.drawer = true
      this.jueseinfo = row
      this.$nextTick(() => {
        this.drawertitle = "添加至用户组：" + row.desc;

        this.$refs['transfer'].init("userGroup", row)

        this.$refs['transfer'].sourceList = [
          {
            title: '', // Collapse 折叠面板 标题
            name: '1', // Collapse 折叠面板 序号
            checkStrictly: true, // 不关联
            toSelectedList: { // 待选数据
              title: '待选', // 待选标题
              search: '',
              disabledSearch: true,
              treeload: true,
              list: []
            },
            selectedList: { // 已选数据
              title: '已选',
              search: '',
              disabledSearch: true,
              treeload: false,
              rawList: [],
              list: []
            }
          },
        ]
      })
    },

    // 筛选列表
    getTransferList(source, row) {
      if (source == "userGroup") {
        // 获取待选组列表
        userfilterHas(row.id).then(response => {
          this.$refs['transfer'].sourceList[0].toSelectedList.treeload = false
          if (response.code == 1) {
            if (response.data.length > 0) {
              this.$refs['transfer'].sourceList[0].toSelectedList.disabledSearch = false
            }
            this.$refs['transfer'].sourceList[0].toSelectedList.list = this.$refs['transfer'].transformList(response.data)
          }
        });
      }
    },

    // 确定添加 分组，添加权限
    handleSaveDrawer(list, row, source) {
      // console.log(row)
      let ids = []
      list[0].selectedList.list.forEach(item => {
        ids.push(item.id)
      })

      const data = {
        groupId: [row.id],
        userId: ids
      }
      userdoAssignGroups(data).then(response => {
        this.$refs['transfer'].butnLoading = false;
        if (response.code == 1) {
          this.$message({
            message: "保存成功",
            type: "success"
          });
          this.$refs['transfer'].drawer = false
          this.drawer = false
          if (this.$refs['group'].juesequanxianlist) {
            this.$refs['group'].getList(row)
          } else {
            this.getList()
          }
        }
      });
    },

  }
}
</script>
